import Vue from 'vue';
import Router from 'vue-router';


// Views - None Coreui

const AdminView = () => import('@/views/admin/AdminView');
const MainView = () => import('@/views/public/MainView');

Vue.use(Router);

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
        path: '/',
        redirect: '/main',
        name: 'UI',
        component: {
            render(c) {
                return c('router-view');
            }
        },
        children: [
            {
                path: '/admin',
                name: 'Admin',
                component: AdminView
            },
            {
                path: '/main',
                name: 'Main',
                component: MainView
            },
        ]
    }
  ]
});
router.beforeEach((to, from, next) => {
    sessionStorage.setItem('redirectPath', from.path);
    next();
});
export default router;
